// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"n7","editButton":"n8","formClass":"n9","rowClass":"n-","columnClass":"n_","inputClass":"oa","email":"ob","mobile":"oc","cancelButton":"od","submitButton":"oe"};